function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48 0V48H0C0 21.4903 21.4903 0 48 0Z",
  fill: "url(#paint0_linear_feat3)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48 22V48H22C22 33.6406 33.6406 22 48 22Z",
  fill: "url(#paint1_linear_feat3)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_feat3",
  x1: -0.00000505447,
  y1: 0,
  x2: -0.00000576973,
  y2: 48,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#61FFF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBFCAA"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_feat3",
  x1: 35,
  y1: 48,
  x2: 33.8564,
  y2: 22.0504,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BBF5EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6DEEE0"
})));

var SvgFeature3 = function SvgFeature3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 48,
    viewBox: "0 0 79 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeature3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feature-3.60f64998.svg";
export { ForwardRef as ReactComponent };